<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    label: string;
    hint?: string;
    hintId?: string;
    children: Snippet;
  }

  const { label, hint, hintId, children }: Props = $props();
</script>

<label class="form-field">
  <span class="field-label">{label}</span>
  {@render children()}
  {#if hint}<small id={hintId} class="field-hint">{hint}</small>{/if}
</label>

<style>
  .form-field {
    display: grid;
    min-width: 0;
    gap: 0.4rem;
    color: var(--muted);
    font-size: 0.82rem;
  }
  .field-hint {
    color: var(--dim);
    font-size: 0.72rem;
    line-height: 1.5;
  }
</style>
